export default __webpack_public_path__ + "static/media/icon-landing-1.a5ce7b47.png";